import { createFileRoute } from "@tanstack/react-router"

import { pageHead } from "@/lib/metadata"
import { getNews } from "@/server/web"
import { Suspense } from "react"
import { Newspaper } from "lucide-react"

import { EmptyState } from "@anysola/ui/empty-state"
import { UnavailableAlert } from "@/components/feedback/unavailable-alert"
import { Container } from "@/components/layout/container"
import { SiteShell } from "@/components/layout/site-shell"
import { NewsBrowser, NewsBrowserFromUrl } from "@/components/news/news-index"
import { NewsSubscribe } from "@/components/news/news-subscribe"

/** The newest post large, the next few beside it, then every post as a row. */
function NewsPage() {
  const posts = Route.useLoaderData()

  return (
    <SiteShell>
      <h1 className="sr-only">News</h1>
      <Container className="space-y-16 pt-10 pb-14 sm:space-y-20 sm:pt-12 sm:pb-16">
        {posts === null ? (
          <UnavailableAlert title="News is unavailable right now." />
        ) : posts.length === 0 ? (
          <EmptyState
            icon={<Newspaper />}
            title="No posts published yet"
            className="w-full py-16"
          />
        ) : (
          <>
            <Suspense fallback={<NewsBrowser posts={posts} />}>
              <NewsBrowserFromUrl posts={posts} />
            </Suspense>
            <NewsSubscribe returnTo="/news" />
          </>
        )}
      </Container>
    </SiteShell>
  )
}

export const Route = createFileRoute("/news/")({
  // Admin edits revalidate this page; the TTL (300 s, in the service) only
  // bounds a direct database edit.
  loader: () => getNews(),
  head: () =>
    pageHead({
      title: "News",
      description: "Launches and announcements from Anysola.",
      path: "/news",
      image: "/news/opengraph-image",
      rss: true,
    }),
  component: NewsPage,
})
